import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Stethoscope, ChevronDown } from "lucide-react";

const DEMO_URL = "https://www.youtube.com/watch?v=LSzQzu-PPNU";
const FEEDBACK_PATIENT_URL =
  "https://docs.google.com/forms/d/1sLnmGfgKje3MGF0j15M0U1AZcXZqm-7My_OV-QUXSlk";
const FEEDBACK_PROVIDER_URL =
  "https://docs.google.com/forms/d/1qsFtEfoNHC_lhYgKOjhjIrAJZ5x2rxgpFCtw8zyUKQY";

export default function HomeHeader() {
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const feedbackRef = useRef();

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (feedbackRef.current && !feedbackRef.current.contains(e.target))
        setFeedbackOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header className="w-full border-b bg-white">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo + tagline */}
        <Link to="/" className="flex flex-col leading-tight">
          <div className="flex items-center gap-2">
            <Stethoscope className="text-teal-600" size={28} />
            <span className="text-2xl font-bold text-gray-900">MedMaze</span>
          </div>
          <span className="text-xs text-gray-400 ml-9">
            Referral Orchestration Engine
          </span>
        </Link>

        {/* Nav links */}
        <nav className="flex items-center gap-6">
          <Link
            to="/ProviderSearchPage"
            className="text-gray-700 hover:text-teal-600 font-medium text-sm transition-colors"
          >
            Find Providers
          </Link>
          <a
            href={DEMO_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-700 hover:text-teal-600 font-medium text-sm transition-colors"
          >
            How It Works
          </a>
          <Link
            to="/features/referral"
            className="text-gray-700 hover:text-teal-600 font-medium text-sm transition-colors"
          >
            Referral Coordination
          </Link>
          <Link
            to="/features/matching"
            className="text-gray-700 hover:text-teal-600 font-medium text-sm transition-colors"
          >
            Provider Smart Matching
          </Link>

          {/* Give Feedback dropdown */}
          <div className="relative" ref={feedbackRef}>
            <button
              type="button"
              onClick={() => setFeedbackOpen((v) => !v)}
              className="flex items-center gap-1 text-gray-700 hover:text-teal-600 font-medium text-sm transition-colors"
            >
              Give Feedback <ChevronDown size={14} />
            </button>
            {feedbackOpen && (
              <div className="absolute right-0 mt-2 w-52 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
                <a
                  href={FEEDBACK_PROVIDER_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block px-4 py-2.5 text-sm text-gray-700 hover:bg-teal-50 hover:text-teal-700 rounded-t-lg"
                  onClick={() => setFeedbackOpen(false)}
                >
                  Give Feedback as a Provider
                </a>
                <a
                  href={FEEDBACK_PATIENT_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block px-4 py-2.5 text-sm text-gray-700 hover:bg-teal-50 hover:text-teal-700 rounded-b-lg border-t border-gray-100"
                  onClick={() => setFeedbackOpen(false)}
                >
                  Give Feedback as a Patient
                </a>
              </div>
            )}
          </div>
        </nav>
      </div>
    </header>
  );
}
